import styled from 'styled-components';

const Loading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: white;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Loading;